
        var result = require("!!../../../../node_modules/css-loader/index.js!./forgot-password.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/forgot-password/forgot-password.component.css
// module id = 675
// module chunks = 0